var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSucessImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 377,
    height: 230,
    viewBox: "0 0 377 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5404",
    "data-name": "Group 5404",
    transform: "translate(-1249 -300)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2922",
    "data-name": "Ellipse 2922",
    cx: 115,
    cy: 115,
    r: 115,
    transform: "translate(1335 300)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5402",
    "data-name": "Group 5402"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6234",
    "data-name": "Rectangle 6234",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1277 355)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6237",
    "data-name": "Rectangle 6237",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1278 375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6238",
    "data-name": "Rectangle 6238",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1261 415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6235",
    "data-name": "Rectangle 6235",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1300 395)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6236",
    "data-name": "Rectangle 6236",
    width: 110,
    height: 20,
    rx: 10,
    transform: "translate(1249 435)",
    fill: "#edfaf2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5403",
    "data-name": "Group 5403",
    transform: "translate(1516 410)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6234-2",
    "data-name": "Rectangle 6234",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(13)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6237-2",
    "data-name": "Rectangle 6237",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(24 20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6238-2",
    "data-name": "Rectangle 6238",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(4 60)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6235-2",
    "data-name": "Rectangle 6235",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(-11 40)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6236-2",
    "data-name": "Rectangle 6236",
    width: 110,
    height: 20,
    rx: 10,
    transform: "translate(-18 80)",
    fill: "#edfaf2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M4.45,34.795v34.9a8.532,8.532,0,0,0,8.523,8.524H53.837a8.532,8.532,0,0,0,8.523-8.524v-34.9a8.549,8.549,0,0,0-8.523-8.524H53.11V20.2a19.7,19.7,0,0,0-39.409,0v6.067h-.727A8.549,8.549,0,0,0,4.45,34.795ZM33.4,46.126a6.117,6.117,0,1,1-6.117,6.117A6.109,6.109,0,0,1,33.4,46.126ZM21.221,20.2a12.184,12.184,0,0,1,24.367,0v6.067H21.221V20.2Z",
    transform: "translate(1408.123 372.307)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2923",
    "data-name": "Ellipse 2923",
    cx: 31.5,
    cy: 32,
    rx: 31.5,
    ry: 32,
    transform: "translate(1445 411)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924",
    "data-name": "Ellipse 2924",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(1450 416)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M17100.145,592.03l7.363,8.828L17124.5,579.8",
    transform: "translate(-15635.684 -147.536)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessImg1);
export default __webpack_public_path__ + "static/media/sucess_img1.2b76bc87720ca1fc958292d0cd73b5f7.svg";
export { ForwardRef as ReactComponent };